import {useCallback} from 'react';
import {Concept} from 'types';
import type {Filter, ViewMode} from 'services/advancedSearch/types';
import {useLazyPostInfoQuery} from 'services/advancedSearch/advancedSearchApi';
import {mapDataToMetadataId} from '../mappers';

export const useGetMetadataIds = () => {
  const [postInfo] = useLazyPostInfoQuery();

  return useCallback(
    (
      viewMode: ViewMode,
      filters: Filter[],
      sort?: string,
      page: number = 0,
      size: number = 200,
    ) => {
      return postInfo({
        type: viewMode,
        filters,
        columns: viewMode === Concept.work ? ['workId'] : ['workId', 'ean'],
        page,
        size,
        sort,
      })
        .unwrap()
        .then(r => (r?.rows ?? []).map(mapDataToMetadataId));
    },
    [postInfo],
  );
};
